import { assign as w, strlen as $, charat as p, trim as x, from as y, substr as B, append as C } from "./index.es135.js";
var u = 1, t = 1, h = 0, a = 0, r = 0, c = "";
function D(n, s, m, b, d, g, k, v) {
  return { value: n, root: s, parent: m, type: b, props: d, children: g, line: u, column: t, length: k, return: "", siblings: v };
}
function F(n, s) {
  return w(D("", null, null, "", null, null, 0, n.siblings), n, { length: -n.length }, s);
}
function I(n) {
  for (; n.root; )
    n = F(n.root, { children: [n] });
  C(n, n.siblings);
}
function J() {
  return r;
}
function K() {
  return r = a > 0 ? p(c, --a) : 0, t--, r === 10 && (t = 1, u--), r;
}
function e() {
  return r = a < h ? p(c, a++) : 0, t++, r === 10 && (t = 1, u++), r;
}
function i() {
  return p(c, a);
}
function G() {
  return a;
}
function o(n, s) {
  return B(c, n, s);
}
function l(n) {
  switch (n) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function L(n) {
  return u = t = 1, h = $(c = n), a = 0, [];
}
function M(n) {
  return c = "", n;
}
function N(n) {
  return x(o(a - 1, f(n === 91 ? n + 2 : n === 40 ? n + 1 : n)));
}
function O(n) {
  for (; (r = i()) && r < 33; )
    e();
  return l(n) > 2 || l(r) > 3 ? "" : " ";
}
function j(n, s) {
  for (; --s && e() && !(r < 48 || r > 102 || r > 57 && r < 65 || r > 70 && r < 97); )
    ;
  return o(n, G() + (s < 6 && i() == 32 && e() == 32));
}
function f(n) {
  for (; e(); )
    switch (r) {
      // ] ) " '
      case n:
        return a;
      // " '
      case 34:
      case 39:
        n !== 34 && n !== 39 && f(r);
        break;
      // (
      case 40:
        n === 41 && f(n);
        break;
      // \
      case 92:
        e();
        break;
    }
  return a;
}
function q(n, s) {
  for (; e() && n + r !== 57 && !(n + r === 84 && i() === 47); )
    ;
  return "/*" + o(s, a - 1) + "*" + y(n === 47 ? n : e());
}
function z(n) {
  for (; !l(i()); )
    e();
  return o(n, a);
}
export {
  L as alloc,
  G as caret,
  J as char,
  r as character,
  c as characters,
  t as column,
  q as commenter,
  F as copy,
  M as dealloc,
  N as delimit,
  f as delimiter,
  j as escaping,
  z as identifier,
  h as length,
  I as lift,
  u as line,
  e as next,
  D as node,
  i as peek,
  a as position,
  K as prev,
  o as slice,
  l as token,
  O as whitespace
};
//# sourceMappingURL=index.es136.js.map
